<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-09-06 15:01:50
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Holiday\PublicHoliday\newPublicHoliday.vue
 -->
<template>
  <ContentLayout
    widthClass="max-1000"
    :title="$t('label_essweb_holiday_form_newTitle')"
    backgroundClass="white"
    :initData="HolidayData"
    @change="(changed) => (isChanged = changed)"
    :checkData="['holiday_name', 'holiday_abbr', 'holiday_utc_date', 'remarks']"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :bindData="HolidayData.holiday_name"
              maxlength="100"
              @change="
                (valueArr) => {
                  HolidayData.holiday_name = valueArr;
                }
              "
              :label="$t('label_essweb_holiday_form_publicHolidayNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :bindData="HolidayData.holiday_abbr"
              maxlength="100"
              @change="
                (valueArr) => {
                  HolidayData.holiday_abbr = valueArr;
                }
              "
              :label="$t('label_essweb_holiday_form_publicHolidayAbbrLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <DateTimePicker
              type="date"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :defaultTime="HolidayData.holiday_utc_date"
              :label="$t('label_essweb_holiday_form_publicHolidayDateLabel')"
              @change="(time) => (HolidayData.holiday_utc_date = time)"
            ></DateTimePicker>
          </v-col>
          <!-- <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_holiday_form_publicHolidayTimeZoneLabel")
            }}</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              single-line
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              v-model="HolidayData.holiday_time_zone"
              dense
              :placeholder="
                $t('label_essweb_holiday_form_publicHolidayTimeZoneLabel')
              "
              filled
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_holiday_form_publicHolidayRemarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              filled
              dense
              maxlength="500"
              single-line
              v-model="HolidayData.remarks"
              counter="500"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>

    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions newBtn @new="toNew" @cancel="$toBack(isChanged)" />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newPublicHoliday",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
  },
  data() {
    return {
      iSEdited: false,
      isChanged: false,
      showDelete: false,
      HolidayData: {
        holiday_name: "",
        holiday_abbr: "",
        holiday_utc_date: "",
        holiday_time_zone: 0,
        remarks: "",
      },
    };
  },
  mounted() {
    // this.HolidayData.holiday_name = this.$getCommonLangKey(this.companyLang);
    // this.HolidayData.holiday_abbr = this.$getCommonLangKey(this.companyLang);
    this.HolidayData.holiday_time_zone = this.defaultUTC;
  },
  methods: {
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_day",
        url: "/holiday/add-holiday-table/",
        data: {
          holiday_name: this.$transCommonLangKey(this.HolidayData.holiday_name),
          holiday_abbr: this.$transCommonLangKey(this.HolidayData.holiday_abbr),
          holiday_utc_date: this.$getTimeValue(
            this.HolidayData.holiday_utc_date
          ),
          // holiday_time_zone: this.HolidayData.holiday_time_zone,
          year: this.$getDateTime(
            this.$getTimeValue(this.HolidayData.holiday_utc_date),
            "YYYY"
          ),
          remarks: this.HolidayData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
